import { useEffect, useState } from "react";
import { connect } from "react-redux";
import Alert from "../../../components/Alert";
import { Actions } from "../../../internals/app/Actions";
import ProductGrid from "../../../components/ProductGrid";
import ProductList from "../../../components/ProductList";
import CategoryList from "../../../components/CategoryList";
import ProductHeader from "../../../components/ProductHeader";
import { filterProductsBySearch } from "../../../internals/managers/ProductManager";

const ProductView = (props: any) => {
  const { openAlertBox, alertStatus, products, selectedShop } = props;
  const [isGrid, setIsGrid] = useState<boolean>(false);
  const [searchText, setSearchText] = useState<string>("");
  const [selectedCategoryId, setSelectedCategoryId] = useState<string | null>(null);

  const shopId = selectedShop?.shopId;
  // The /products lambda pages through DynamoDB itself and returns the whole
  // catalogue in one response, so everything is already here to search.
  const loadedProducts = products?.products || [];

  /** Clear the query on a shop change, so stale text cannot hide a catalogue. */
  useEffect(() => {
    setSearchText("");
  }, [shopId]);

  const toggleGridList = (status: boolean) => {
    setIsGrid(status);
    setSelectedCategoryId(null);
  };

  const resultCount = searchText
    ? filterProductsBySearch(loadedProducts, searchText).length
    : loadedProducts.length;

  return (
    <div className="h-screen flex flex-col w-full p-6">
      <Alert
        alertStatus={alertStatus}
        onCloseAlert={(status: any) =>
          openAlertBox(status, false, alertStatus.successStatus)
        }
      />
      <div className="pb-6 flex-shrink-0">
        <ProductHeader
          isGrid={isGrid}
          searchText={searchText}
          onSearchChange={(value: string) => setSearchText(value)}
          resultCount={resultCount}
          totalCount={loadedProducts.length}
          toggleGridList={(status) => toggleGridList(status)}
        />
      </div>

      {isGrid ? (
        <div className="flex-1 min-h-0 grid grid-cols-1 gap-6 sm:grid-cols-7">
          <div className="col-span-1 overflow-y-auto">
            <CategoryList
              selectedCategoryId={selectedCategoryId}
              onSelectCategory={(id: string | null) => setSelectedCategoryId(id)}
            />
          </div>
          <div className="col-span-6 min-h-0 h-full">
            <ProductGrid
              selectedCategoryId={selectedCategoryId}
              searchText={searchText}
            />
          </div>
        </div>
      ) : (
        <div className="flex-1 min-h-0 overflow-y-auto">
          <ProductList searchText={searchText} />
        </div>
      )}
    </div>
  );
};

export default connect(
  (state: any) => ({
    products: state.product.get("products"),
    alertStatus: state.common.get("alertStatus"),
    selectedShop: state.dashboard.get("selectedShop"),
  }),
  {
    openAlertBox: Actions.common.openAlertBox,
  }
)(ProductView);
